const INSPECTION_ACTIVITIES = {
  INSPECTION_STARTED: 'inspection_started',
  INSPECTION_FINISHED: 'inspection_finished',
  INSPECTION_NEW_INSPECTOR: 'inspection_new_inspector',
  INSPECTION_MANUAL_INSPECTION_CREATED: 'inspection_manual_inspection_created',
  INSPECTION_UNASSIGNED_INSPECTOR: 'inspection_unassigned_inspector',
};

export default INSPECTION_ACTIVITIES;
